import { forwardRef, system } from '@hover/blueprint';
import React from 'react';
import { Trans } from 'react-i18next';

import type { TextOverlayProps } from 'src/modules/homeownerApp/components/Customize/TextOverlay';
import { TextOverlay } from 'src/modules/homeownerApp/components/Customize/TextOverlay';
import { useHomeownerTranslate } from 'src/modules/homeownerApp/hooks';

import { LoadingTextEllipsis } from '../../LoadingText';

export interface LoadingOverlayProps
  extends Exclude<TextOverlayProps, 'children'> {}

export const LoadingOverlay = forwardRef<LoadingOverlayProps, 'div'>(
  (props, ref) => {
    const t = useHomeownerTranslate();

    return (
      <TextOverlay ref={ref} {...props}>
        <system.span whiteSpace="nowrap">
          <Trans
            components={{
              Ellipsis: <LoadingTextEllipsis />,
            }}
            i18nKey="customize.overlay.loading"
            t={t}
          />
        </system.span>
      </TextOverlay>
    );
  },
);
